export const DrawerData = [
  "About",
  "Blog",
  "Experience",
  //   "Education",
  "Projects",
];
